import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


const Videos = () => {
  return (
    <div>
      <Container>
        <h4 className='text-center mt-5 mb-5'>Our Video Gallery</h4>
        <Row className='d-flex justify-content-evenly mb-5'>
          <h5 className='mt-5 mb-5 text-center'>Some Local News Channel </h5>
          <Col md={4}>
          <iframe style={{borderRadius:'15px'}} width='100%' height='250px' src="https://www.youtube.com/embed/MjPTT3kK0SI?si=Cqw4hkvligRhferM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </Col>
          <Col md={4}>
          <iframe style={{borderRadius:'15px'}} width='100%' height='250px' src="https://www.youtube.com/embed/Ad7OAZs3We4?si=FBCqqSAM7s7x5JY3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </Col>
          <Col md={4}>
          <iframe style={{borderRadius:'15px'}} width='100%' height='250px' src="https://www.youtube.com/embed/tqQHHwyWXG4?si=pN5ogH6OQvxKJjB4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </Col>
        </Row>
        <Row>
          <h5 className='text-center mt-5 mb-5'>Our Personal Section</h5>
          <Col md={3}>
          </Col>
          <Col md={3}>
          </Col>
          <Col md={3}>
          </Col>
        </Row>
        {/* <Row>
          <Col md={3}>
          </Col>
          <Col md={3}>
          </Col>
          <Col md={3}>
          </Col>
        </Row> */}
      </Container>
    </div>
  )
}

export default Videos